<script setup>
import { inject, ref } from 'vue';

const mq = inject(['mq']);

const isActive = ref(false);

const activeToggle = () => {
    if (mq.lgPlus) return;
    isActive.value = !isActive.value;
}

const doWhenActive = (el) => {
    el.style.height = el.scrollHeight + 'px';
}

const doWhenInactive = (el) => {
    el.style.height = '0';
}
</script>

<template>
<div class="people__accordion" :class="{ 'is-active': isActive }">
    <h3 class="people__catch" @click="activeToggle">
        <slot name="head"></slot>
        <div class="acco-icon people__icon" :class="{ 'is-active': isActive }"></div>
    </h3>
    <transition @before-enter="doWhenInactive" @enter="doWhenActive" @before-leave="doWhenActive" @leave="doWhenInactive">
        <div class="people__accordion-body" v-if="isActive || mq.lgPlus">
            <p class="people__txt"><slot name="body"></slot></p>
        </div>
    </transition>
</div>
</template>